let cached = null;

function readBuildTime() {
  const v = process.env.REACT_APP_ENV;
  return v === 'development' || v === 'test' || v === 'staging' ? v : 'production';
}

export function _reset() { cached = null; }

export function isProduction() {
  if (cached != null) return cached === 'production';
  return readBuildTime() === 'production';
}

export async function boot(apiBase = '/api/v1') {
  try {
    const res = await fetch(`${apiBase}/meta/env`, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('bad_status');
    const body = await res.json();
    const allowed = new Set(['development', 'test', 'staging', 'production']);
    cached = allowed.has(body.env) ? body.env : 'production';
  } catch {
    cached = 'production'; // fail closed
  }
}
